export const USERSETUP_GET = 'USERSETUP_GET';
export const USERSETUP_GET_ROLES = 'USERSETUP_GET_ROLES';
export const USERSETUP_ERROR = 'USERSETUP_ERROR';

export const USERSETUP_SET_SHOW_INACTIVE = 'USERSETUP_SET_SHOW_INACTIVE';
export const USERSETUP_SET_FILTERED_DATA = 'USERSETUP_SET_FILTERED_DATA';

//for dispatching and wait cursors
export const USERSETUP_POST = 'USERSETUP_POST';
export const USERSETUP_BEGIN_SUBMIT = 'USERSETUP_BEGIN_SUBMIT';
export const USERSETUP_END_SUBMIT = 'USERSETUP_END_SUBMIT';
export const USERSETUP_HAD_ERROR = 'USERSETUP_HAD_ERROR';

export const USERSETUP_CLEAR_ERRORS = 'USERSETUP_CLEAR_ERRORS';

export const USERSETUP_SET_USER_GRIDLOADING = 'USERSETUP_SET_USER_GRIDLOADING';
export const USERSETUP_SET_ASSIGN_GRIDLOADING =
  'USERSETUP_SET_ASSIGN_GRIDLOADING';
export const USERSETUP_SET_ASSIGN_SITE_DATA = 'USERSETUP_SET_ASSIGN_SITE_DATA';
export const USERSETUP_UPDATE_ASSIGN_SITE_DATA =
  'USERSETUP_UPDATE_ASSIGN_SITE_DATA';
export const USERSETUP_CLEAR_ASSIGN_SITE_DATA =
  'USERSETUP_CLEAR_ASSIGN_SITE_DATA';
export const USERSETUP_CHECKALL_ASSIGN_SITE_DATA =
  'USERSETUP_CHECKALL_ASSIGN_SITE_DATA';
export const USERSETUP_SET_ASSIGN_CURRENT_USER =
  'USERSETUP_SET_ASSIGN_CURRENT_USER';
export const USERSETUP_UPDATE_IS_PAGE_ACCESSIBLE =
  'USERSETUP_UPDATE_IS_PAGE_ACCESSIBLE';



// WEBPACK FOOTER //
// ./src/pages/usersetup/state/types.js